<app-capital-card role="button" (click)="onClick()" (keydown.enter)="onClick()" tabindex="0" shadow="small" [class.loading]="isLoading()">
    <div class="option-padding h-100 d-flex flex-column justify-content-between">
        @if (isLoading()) {
        <div class="loading-overlay">
            <p>Cargando...</p>
        </div>
        }
        <div class="d-flex align-items-center mb-3">
            <img [src]="icon()" alt="" class="me-3">
            <h3 class="home-card-title m-0">{{ title() }}</h3>
        </div>
        <p class="option-caption flex-fill">{{ caption() }} </p>
        <div class="d-flex align-items-center justify-content-end ">
            <p class="action m-0 me-4">{{ action() }}</p>
            <img src="/img/back-arrow.svg" style="transform: rotate(180deg); width: 1.2rem;" alt="">
        </div>
    </div>
</app-capital-card>